import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { LocalizeAndPluralizePeriodPipe } from '@lx/shared/ui/pipes';
import { DialogBasedSelector } from '@lx/quote-tool/lite/shared/ui/directives';
import { DurationSelectorComponent } from '../duration-selector/duration-selector.component';
import { SelectorFieldContainerComponent, SidePanelComponent } from '@lx/quote-tool/lite/shared/ui/components';

@Component({
  standalone: true,
  selector: 'lx-duration-selector-field',
  templateUrl: './duration-selector-field.component.html',
  styleUrls: ['./duration-selector-field.component.scss'],
  imports: [
    SidePanelComponent,
    SelectorFieldContainerComponent,
    DurationSelectorComponent,
    LocalizeAndPluralizePeriodPipe,
    NgIf,
    SelectorFieldContainerComponent,
  ],
})
export class DurationSelectorFieldComponent extends DialogBasedSelector<number> {}
